<mat-card class="one-card-flat" oneCard style="position:relative">

  <one-table>

    <one-table-content>
      <mat-table 
        [dataSource]="dataSource" 
        matTableExporter matSort multiTemplateDataRows 
        #exporter="matTableExporter"
        class="tblRecepient"
      >

        <ng-container matColumnDef="select">

          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox 
              (change)="$event ? masterToggle($event) : null"
              [checked]="selection.hasValue() && isAllSelected($event)"
              [indeterminate]="selection.hasValue() && !isAllSelected($event)">
            </mat-checkbox>
          </mat-header-cell>

          <mat-cell (click)="handleChecked(row)" *matCellDef="let row">
            <mat-checkbox 
              (change)="$event ? selection.toggle(row) : null; selectedRow = row"
              (click)="$event.stopPropagation()" 
              [checked]="selection.isSelected(row)" 
              [disabled]="row.disabled">
            </mat-checkbox>
          </mat-cell>

        </ng-container>

        <ng-container *ngFor="let column of selectedRecepientColumns" [matColumnDef]="column.value">

          <mat-header-cell *matHeaderCellDef mat-sort-header [title]="column.key">
            <span>{{ column.key }}</span>
          </mat-header-cell>
          
          <mat-cell *matCellDef="let element">

            <div class="truncate-text" *ngIf="column.value != 'Status';  else displayStatusChip">

              <span [title]="element[column.value]" class="truncate-text" *ngIf="column.value == 'CustomerContactName' || column.value == 'CustomerContactEmail'; else displayDateField ">
                {{ element[column.value] }}
              </span>
              
              <ng-template #displayDateField>
                <container-element [ngSwitch]="column.value">
                  <span [title]="getReminderSent(element.CustomerReminderDetails)" class="truncate-text" *ngSwitchCase="'ReminderSent'">{{ getReminderSent(element.CustomerReminderDetails) }}</span>
                  <span [title]="getReminderPlanned(element.CustomerReminderDetails)" class="truncate-text" *ngSwitchCase="'ReminderPlanned'">{{ getReminderPlanned(element.CustomerReminderDetails) }}</span>
                  <span [title]="appUtils.formatDateWithTime(element[column.value])" class="truncate-text" *ngSwitchDefault>{{ appUtils.formatDateWithTime(element[column.value]) }}</span>
                </container-element>
              </ng-template>

            </div>

            <ng-template #displayStatusChip>
              <mat-chip [title]="element.Status" class="notification-list-source-chip truncate-text" oneChip oneChipAppearance="outline">
                {{ displayStatus(element.Status) }}
              </mat-chip>
            </ng-template>

          </mat-cell>

        </ng-container>

        <ng-container matColumnDef="Arrow">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <i class="one-icons" (click)="gotoContactDetailsPage(element)">
              arrow_right
            </i>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row 
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{ checked: selection.isSelected(row), disabled: row.disabled }" 
          class="one-element-row"
          (click)="gotoContactDetailsPage(row)">
        </mat-row>

      </mat-table>
    </one-table-content>

    <one-table-footer class="table-footer">

      <div class="left-button">
        <button (click)="ndResendNotification()" [disabled]="selection.selected.length < 1" mat-stroked-button one-secondary-button *ngIf="userPermission.SendNotification && !isAddRecipientDisabled && !isSetCom">
          Resend notifications
        </button>
      </div>

    </one-table-footer>

  </one-table>

  <div class="noDataViewRecipient" *ngIf="contactDetails.length < 1 || dataSource.data.length < 1 || dataSource.filteredData.length < 1">
    <ng-container *ngIf="contactDetails.length < 1; else noFilteredData">
      No data available.
    </ng-container>
    <ng-template #noFilteredData>
      <ng-container *ngIf="dataSource.data.length < 1; else noSearchedData">
        No data available with given filter criteria.
      </ng-container>
      <ng-template #noSearchedData>
        <ng-container *ngIf="dataSource.filteredData.length < 1">
          No data available with given search criteria.
        </ng-container>
      </ng-template>
    </ng-template>
  </div>

</mat-card>
